import { AxiosError } from "axios";
import { ApiError } from "../types";

export const getApiErrorMessage = (error: AxiosError<ApiError> | null) => {
  const errorResponse = error?.response?.data.response;

  if (!errorResponse) return "Something went wrong";

  return Array.isArray(errorResponse) ? errorResponse[0] : errorResponse;
};
